(() => {
  'use strict';
  if (window.MiniPowerVorkasse) { window.MiniPowerVorkasse.init(); return; }
  const instances = new Map();
  const money = cents => new Intl.NumberFormat('de-DE', {style:'currency', currency:'EUR'}).format(cents / 100);
  const offer = () => {
    // Scala renders its active configuration as a Ruby hash in the app embed.
    try {
      const template = document.querySelector('#scala-button-template');
      const config = JSON.parse(document.querySelector('#scala-button-restrict')?.content.querySelector('[data-kind="config"]')?.textContent.replace(/=>/g, ':') || '{}');
      const rate = Number(config.discountValue);
      if (!template || !Number(template.dataset.hasconfig) || config.id !== '1' || config.discountType !== 'percent' || config.contextType !== 'All' || !(rate > 0 && rate < 100) || !config.paymentMethods?.some(method => /vorkasse/i.test(method))) return null;
      const now = Date.now();
      if (template.dataset.startdate && now < Date.parse(template.dataset.startdate)) return null;
      if (template.dataset.enddate && now > Date.parse(template.dataset.enddate)) return null;
      return {...config, rate};
    } catch (_) { return null; }
  };
  const requestCart = async (path = 'cart.js', payload) => {
    const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
      method: payload === undefined ? 'GET' : 'POST', cache:'no-store',
      headers:{'Content-Type':'application/json', 'Accept':'application/json', 'X-Scala-Internal':'1'},
      ...(payload === undefined ? {} : {body:JSON.stringify(payload)})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) {
      const error = new Error(typeof data.description === 'string' ? data.description : 'Der Warenkorb konnte nicht aktualisiert werden. Bitte prüfe deine Auswahl.');
      error.rejected = true;
      throw error;
    }
    return data;
  };
  const normalizeCode = value => String(value || '').trim().toLocaleLowerCase('de-DE');
  const cartCodes = cart => (cart.discount_codes || []).map(entry => entry.code).filter(Boolean);
  const uniqueCodes = codes => codes.filter((code, index) => codes.findIndex(other => normalizeCode(other) === normalizeCode(code)) === index);
  const itemKey = item => JSON.stringify({id:String(item.variant_id || item.id), properties:Object.fromEntries(Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b))), selling_plan:String(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || '')});
  const countItem = (cart, key) => cart.items.filter(item => itemKey(item) === key).reduce((sum,item) => sum + item.quantity, 0);
  const skonto = (cart, config) => (cart.cart_level_discount_applications || []).find(entry => {
    const application = entry.discount_application || entry;
    return application.title === config.message && Number(application.value) === config.rate;
  });
  const init = () => document.querySelectorAll('[data-mp-vorkasse]').forEach(element => {
    if (instances.has(element)) return;
    const root = element.closest('[data-mp-product-root]');
    const buybox = element.closest('[data-mp-buybox]');
    const form = element.closest('form[action*="/cart/add"]');
    if (!root || !buybox || !form) return;
    const opener = element.querySelector('[data-mp-vorkasse-open]');
    const dialog = element.querySelector('[data-mp-vorkasse-dialog]');
    const confirm = element.querySelector('[data-mp-vorkasse-confirm]');
    const errorNode = element.querySelector('[data-mp-vorkasse-error]');
    const input = element.querySelector('[data-mp-vorkasse-code]');
    const apply = element.querySelector('[data-mp-vorkasse-apply]');
    const remove = element.querySelector('[data-mp-vorkasse-remove]');
    const status = element.querySelector('[data-mp-vorkasse-code-status]');
    const receiptKey = 'mp-vorkasse-receipt:' + element.dataset.productId;
    let busy = false, uncertain = false, receipt = null, verifiedCart = null, verifiedKey = '', appliedInput = '', invalidCode = false;
    try { receipt = JSON.parse(sessionStorage.getItem(receiptKey) || 'null'); } catch (_) {}
    const saveReceipt = value => {
      receipt = value;
      try { if (value) sessionStorage.setItem(receiptKey, JSON.stringify(value)); else sessionStorage.removeItem(receiptKey); } catch (_) {}
    };
    const selectionKey = items => JSON.stringify(items.map(item => ({...item, properties:Object.fromEntries(Object.entries(item.properties || {}).filter(([key]) => key !== '_mp_set_id').sort(([a],[b]) => a.localeCompare(b)))})));
    const price = id => window.MiniPowerTax?.getVariantDisplayCents?.(id, null);
    const selectedId = () => { const field = form.querySelector('[name="id"]'); return field && !field.disabled ? field.value : null; };
    const showError = message => { errorNode.textContent = message; errorNode.hidden = !message; };
    const showStatus = (message, error = false) => {
      status.textContent = message; status.hidden = !message; status.dataset.error = String(error);
      input.setAttribute('aria-invalid', String(error));
    };
    const assertPurchasable = () => {
      if (buybox.dataset.mpEmailOnly === 'true' || root.dataset.mpSetCheckoutBlocked === 'true' || form.dataset.mpPurchasable === 'false' || form.querySelector('[data-mp-add]')?.matches(':disabled')) throw new Error('Diese Auswahl ist momentan nicht bestellbar. Bitte prüfe Produkt und Zubehör.');
    };
    const readSelection = () => {
      if (!window.MiniPowerTax?.buildProductCartItems) throw new Error('Die Produktauswahl wird geladen. Bitte versuche es erneut.');
      const items = window.MiniPowerTax.buildProductCartItems(form);
      if (!items.length) throw new Error('Bitte wähle eine verfügbare Produktvariante.');
      const rows = items.map((item, index) => {
        const cents = price(item.id);
        if (!Number.isSafeInteger(cents) || cents < 0 || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('Ein Zubehörpreis konnte nicht geladen werden. Bitte lade die Seite neu.');
        const accessory = [...root.querySelectorAll('[data-accessory-row]')].find(row => String(window.MiniPowerTax.getMappedVariantId(row.dataset.variantId)) === String(item.id));
        const cableOptions = JSON.parse(root.querySelector('[data-mp-set-cable-options]')?.textContent || '{}').options || [];
        const cable = cableOptions.find(option => option.variantId && String(window.MiniPowerTax.getMappedVariantId(option.variantId)) === String(item.id));
        const name = index === 0 ? element.dataset.productTitle : accessory?.querySelector('.mp-accessories__info label, .mp-accessories__info a')?.textContent.trim() || (cable ? `${cable.kind.toUpperCase()}-Kabel: ${cable.label}` : 'Gewähltes Set-Zubehör');
        return {name, quantity:item.quantity, cents:cents * item.quantity};
      });
      return {items, rows, subtotal:rows.reduce((total, row) => total + row.cents, 0)};
    };

    const renderItems = rows => {
      const list = element.querySelector('[data-mp-vorkasse-items]');
      list.replaceChildren();
      rows.forEach(row => {
        const li = document.createElement('li'), label = document.createElement('span'), amount = document.createElement('span');
        label.textContent = `${row.quantity} × ${row.name}`; amount.textContent = money(row.cents);
        li.append(label, amount); list.append(li);
      });
    };
    const drawSelection = config => {
      const selection = readSelection();
      renderItems(selection.rows);
      element.querySelector('[data-mp-vorkasse-heading]').textContent = 'Deine Auswahl inkl. Zubehör';
      const saving = Math.floor(selection.subtotal * config.rate / 100);
      element.querySelector('[data-mp-vorkasse-subtotal]').textContent = money(selection.subtotal);
      element.querySelector('[data-mp-vorkasse-total-saving]').textContent = '− ' + money(saving);
      element.querySelector('[data-mp-vorkasse-total]').textContent = money(selection.subtotal - saving);
      element.querySelector('[data-mp-vorkasse-coupon-row]').hidden = true;
      return selection;
    };
    const drawCart = (cart, config) => {
      const application = skonto(cart, config);
      const saving = Number(application?.amount ?? application?.total_allocated_amount ?? application?.discount_application?.total_allocated_amount ?? 0);
      if (![cart.original_total_price, cart.total_price, cart.total_discount, saving].every(Number.isSafeInteger)) throw new Error('Der Endpreis konnte nicht bestätigt werden. Bitte prüfe deinen Warenkorb.');
      renderItems(cart.items.map(item => ({name:item.product_title || item.title, quantity:item.quantity, cents:item.original_line_price})));
      element.querySelector('[data-mp-vorkasse-heading]').textContent = 'Dein Warenkorb inkl. Zubehör';
      element.querySelector('[data-mp-vorkasse-subtotal]').textContent = money(cart.original_total_price);
      element.querySelector('[data-mp-vorkasse-total-saving]').textContent = '− ' + money(saving);
      const otherSaving = Math.max(0, cart.total_discount - saving);
      element.querySelector('[data-mp-vorkasse-coupon-row]').hidden = otherSaving === 0;
      element.querySelector('[data-mp-vorkasse-coupon-saving]').textContent = '− ' + money(otherSaving);
      element.querySelector('[data-mp-vorkasse-total]').textContent = money(cart.total_price);
    };
    const controls = () => {
      let unavailable = false;
      try { assertPurchasable(); } catch (_) { unavailable = true; }
      confirm.disabled = busy || uncertain || unavailable || invalidCode || normalizeCode(input.value) !== normalizeCode(appliedInput);
      apply.disabled = busy || uncertain || unavailable;
      remove.disabled = busy || uncertain;
      input.disabled = busy;
      remove.hidden = !input.value.trim() && !receipt?.ownedCode;
      dialog.toggleAttribute('aria-busy', busy);
      apply.textContent = busy ? 'Wird geprüft …' : 'Anwenden';
      confirm.textContent = busy ? 'Warenkorb wird geprüft …' : 'Weiter zur Vorkasse-Kasse';
      element.querySelector('[data-mp-vorkasse-cart-link]').hidden = !(receipt || uncertain);
    };
    const clearVerified = () => { verifiedCart = null; verifiedKey = ''; };
    const checkReceipt = cart => {
      if (!receipt) return;
      if (receipt.token !== cart.token) { saveReceipt(null); return; }
      if (receipt.expected.every(item => countItem(cart, item.key) >= item.quantity)) {
        if (receipt.phase !== 'added') saveReceipt({...receipt, phase:'added'});
        uncertain = false;
        return;
      }
      uncertain = true;
      throw new Error('Dein Warenkorb wurde geändert oder die letzte Anfrage ist noch unklar. Bitte prüfe den Warenkorb, bevor du diese Auswahl erneut hinzufügst.');
    };
    const prepareCart = async selection => {
      let cart = await requestCart();
      checkReceipt(cart);
      if (receipt) {
        if (receipt.selection !== selectionKey(selection.items)) throw new Error('Deine vorherige Auswahl ist bereits im Warenkorb. Bitte passe sie dort an, bevor du eine andere Auswahl hinzufügst.');
        return cart;
      }
      const quantities = new Map();
      selection.items.forEach(item => { const key = itemKey(item); quantities.set(key, (quantities.get(key) || 0) + item.quantity); });
      saveReceipt({token:cart.token, selection:selectionKey(selection.items), phase:'pending', ownedCode:'', expected:[...quantities].map(([key,quantity]) => ({key,quantity:countItem(cart,key)+quantity}))});
      try {
        await requestCart('cart/add.js', {items:selection.items});
        cart = await requestCart();
        checkReceipt(cart);
        if (!receipt) throw new Error('Der Warenkorb hat sich geändert. Bitte prüfe ihn vor dem Fortfahren.');
        return cart;
      } catch (error) {
        if (error.rejected) saveReceipt(null);
        else uncertain = true;
        throw error;
      }
    };
    const updateDiscount = async (cart, config, code, removing) => {
      const oldCodes = cartCodes(cart);
      const ownedCode = receipt?.ownedCode;
      const replacedCode = ownedCode || (removing ? appliedInput : '');
      let codes = oldCodes.filter(value => !replacedCode || normalizeCode(value) !== normalizeCode(replacedCode));
      if (!removing && code) codes.push(code);
      codes = uniqueCodes(codes);
      await requestCart('cart/update.js', {attributes:{_scaladiscount:config.id}, discount:codes.join(',')});
      let updated = await requestCart();
      const applicable = !code || removing || updated.discount_codes?.some(entry => normalizeCode(entry.code) === normalizeCode(code) && entry.applicable === true);
      if (!applicable) {
        await requestCart('cart/update.js', {discount:oldCodes.join(','), attributes:{_scaladiscount:config.id}});
        updated = await requestCart();
        drawCart(updated, config);
        invalidCode = true;
        showStatus('Dieser Rabattcode ist für deinen Warenkorb nicht gültig oder nicht kombinierbar. Bitte prüfe den Code oder entferne ihn.', true);
        return null;
      }
      if (updated.attributes?._scaladiscount !== config.id || !skonto(updated, config)) {
        drawCart(updated, config);
        invalidCode = true;
        if (receipt) saveReceipt({...receipt, ownedCode:!removing && code && !oldCodes.some(value => normalizeCode(value) === normalizeCode(code)) ? code : ownedCode});
        showStatus('Dieser Rabatt ist nicht mit dem Vorkasse-Skonto kombinierbar. Bitte entferne den Rabattcode oder prüfe deinen Warenkorb.', true);
        return null;
      }
      const nextOwnedCode = !removing && code && (normalizeCode(ownedCode) === normalizeCode(code) || !oldCodes.some(value => normalizeCode(value) === normalizeCode(code))) ? code : '';
      if (receipt) saveReceipt({...receipt, ownedCode:nextOwnedCode});
      appliedInput = removing ? '' : code;
      invalidCode = false;
      return updated;
    };
    const calculate = async ({checkout = false, removing = false} = {}) => {
      if (busy || uncertain) return;
      const config = offer();
      if (!config) { showError('Vorkasse ist momentan nicht verfügbar. Bitte versuche es später erneut.'); return; }
      let selection;
      const code = removing ? '' : input.value.trim();
      if (code.includes(',')) { invalidCode = true; showStatus('Bitte gib jeweils einen Rabattcode ein.', true); controls(); return; }
      if (!checkout && !removing && !code) { showStatus('Bitte gib einen Rabattcode ein.', true); input.focus(); return; }
      try { selection = readSelection(); assertPurchasable(); } catch (error) { showError(error.message); controls(); return; }
      if (!form.reportValidity()) return;
      busy = true; controls(); showError(''); showStatus('Dein Warenkorb wird geprüft …'); clearVerified();
      try {
        let cart = await prepareCart(selection);
        cart = await updateDiscount(cart, config, code, removing);
        if (!cart) return;
        checkReceipt(cart);
        if (selectionKey(readSelection().items) !== selectionKey(selection.items)) throw new Error('Deine Auswahl hat sich während der Prüfung geändert. Bitte prüfe den Warenkorb.');
        verifiedCart = cart; verifiedKey = selectionKey(selection.items);
        if (removing) input.value = '';
        drawCart(cart, config);
        showStatus(code && !removing ? `Rabattcode „${code}“ angewendet. Der Gesamtpreis enthält alle bestätigten Rabatte.` : 'Der Gesamtpreis wurde mit Vorkasse-Skonto aktualisiert.');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (checkout) {
          const target = new URL((window.Shopify?.routes?.root || '/') + 'checkout', location.origin);
          target.searchParams.set('skip_shop_pay', 'true');
          const activeCodes = (cart.discount_codes || []).filter(entry => entry.applicable).map(entry => entry.code);
          if (activeCodes.length) target.searchParams.set('discount', activeCodes.join(','));
          location.assign(target.href);
        }
      } catch (error) {
        invalidCode = false;
        showStatus('', false);
        showError(uncertain ? 'Die Warenkorb-Anfrage konnte nicht bestätigt werden. Bitte prüfe zuerst deinen Warenkorb, bevor du Artikel erneut hinzufügst.' : error.message || 'Der Warenkorb konnte nicht geprüft werden. Bitte versuche es erneut.');
        element.querySelector('[data-mp-vorkasse-total]').textContent = '—';
      } finally { busy = false; controls(); }
    };
    const refresh = () => {
      if (busy) return;
      const config = offer(), id = selectedId(), cents = price(id);
      const currency = document.getElementById('mp-tax-selector')?.dataset.currency || element.dataset.currency;
      const visible = config && currency === 'EUR' && Number.isSafeInteger(cents) && cents > 0 && (element.dataset.formerPickup === 'true' || cents > 80000) && buybox.dataset.mpEmailOnly !== 'true';
      element.hidden = !visible;
      if (!visible) { if (dialog.open) dialog.close(); return; }
      const saving = Math.floor(cents * config.rate / 100);
      element.querySelector('[data-mp-vorkasse-regular]').textContent = money(cents);
      element.querySelector('[data-mp-vorkasse-price]').textContent = money(cents - saving);
      element.querySelector('[data-mp-vorkasse-saving]').textContent = money(saving);
      element.querySelectorAll('[data-mp-vorkasse-rate]').forEach(node => node.textContent = config.rate + ' %');
    };

    const refreshDialog = () => {
      if (busy || !dialog.open) return;
      try {
        const config = offer();
        if (!config) return;
        const selection = readSelection();
        if (verifiedCart && verifiedKey === selectionKey(selection.items)) drawCart(verifiedCart, config);
        else {
          drawSelection(config);
          if (receipt && receipt.selection !== selectionKey(selection.items)) showError('Deine vorherige Auswahl ist bereits im Warenkorb. Bitte prüfe den Warenkorb.');
        }
        assertPurchasable();
      } catch (error) { showError(error.message); }
      controls();
    };
    opener.addEventListener('click', async () => {
      refresh(); if (element.hidden) return;
      showError('');
      dialog.showModal();
      refreshDialog();
      if (receipt && !busy) {
        busy = true; controls();
        try {
          const cart = await requestCart();
          checkReceipt(cart);
          if (receipt && receipt.selection === selectionKey(readSelection().items)) {
            const owned = receipt.ownedCode;
            const matched = owned && cart.discount_codes?.some(entry => normalizeCode(entry.code) === normalizeCode(owned) && entry.applicable);
            if (matched && !input.value.trim()) { input.value = owned; appliedInput = owned; }
            verifiedCart = cart; verifiedKey = receipt.selection;
            drawCart(cart, offer());
            showStatus('Deine Auswahl ist bereits im Warenkorb. Beim Fortfahren wird sie nicht erneut hinzugefügt.');
          }
        } catch (error) { showError(error.message); }
        finally { busy = false; controls(); }
      }
    });
    element.querySelector('[data-mp-vorkasse-close]').addEventListener('click', () => { if (!busy) dialog.close(); });
    dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
    dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
    input.addEventListener('input', () => { invalidCode = false; showStatus('Bitte wende den geänderten Rabattcode an.'); controls(); });
    input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); calculate(); } });
    apply.addEventListener('click', () => calculate());
    remove.addEventListener('click', () => {
      if (!receipt?.ownedCode && normalizeCode(input.value) !== normalizeCode(appliedInput)) {
        input.value = appliedInput; invalidCode = false; showStatus('Die Eingabe wurde verworfen. Bestehende Rabatte bleiben erhalten.'); controls();
      } else calculate({removing:true});
    });
    confirm.addEventListener('click', () => calculate({checkout:true}));
    root.addEventListener('change', event => { if (!element.contains(event.target)) requestAnimationFrame(() => { refresh(); refreshDialog(); }); });
    window.addEventListener('pageshow', event => { if (event.persisted) { busy = false; clearVerified(); controls(); refresh(); refreshDialog(); } });
    instances.set(element, {refresh:() => { refresh(); refreshDialog(); }}); refresh();
  });
  const refreshAll = () => { init(); instances.forEach((instance, element) => { if (element.isConnected) instance.refresh(); else instances.delete(element); }); };
  ['DOMContentLoaded','mp:product-variant-change','mp:tax-role-changed','mp:tax-content-ready','currency:update','shopify:section:load','mp:variant-state-ready'].forEach(name => document.addEventListener(name, refreshAll));
  window.MiniPowerVorkasse = {init:refreshAll}; refreshAll();
  [300, 1000, 3000].forEach(delay => setTimeout(refreshAll, delay));
})();
